import { LocalizedDateFromUtc, SpacedDash } from '@mews-commander/ui';

export const DateGroupLabel = ({ startUtc, endUtc }: { startUtc?: string; endUtc?: string }) => (
    <>
        {startUtc === undefined ? null : <LocalizedDateFromUtc utcString={startUtc} />}
        {SpacedDash}
        {endUtc === undefined ? null : <LocalizedDateFromUtc utcString={endUtc} />}
    </>
);
